import { isMCloudEmbedded } from "@src/utils";

export function bytesToMB(bytes) {
  const bytesPerMB = 1024 * 1024;
  const megabytes = bytes / bytesPerMB;
  return megabytes;
}

class ApiHeaders {
  constructor() {
    this.versionHeaders = {
      "X-SCRIBENOTE-WEB-VERSION": import.meta.env.VITE_APP_VERSION,
      "X-SCRIBENOTE-USER-DEVICE": "web",
    };
    this.accessCsrf = null;
  }

  headers() {
    const headers = {
      ...this.versionHeaders,
      "Content-Type": "application/json",
    };
    if (this.accessCsrf) {
      headers["X-CSRF-Token"] = this.accessCsrf;
    }
    if (isMCloudEmbedded()) {
      headers["X-SCRIBENOTE-INTEGRATION"] = "mcloud";
    }
    return headers;
  }
}

export const API_HEADERS = new ApiHeaders();
